import { Cms_EditorData, Cms_SingleMedia, Cms_TitleTag } from '@lib/services/cms/types';

import { Cms_ContentSlice } from '../pages.types';

export interface Cms_ContentNewsletterSignup extends Cms_ContentSlice {
  __component: 'content.newsletter-signup';
  title: string;
  titleHtmlTag?: Cms_TitleTag;
  teaser?: string;
  text?: Cms_EditorData;
  bgImage?: Cms_SingleMedia;
  odooMailingListIds?: string;
}

export const populateNewsletterSignup = {
  populate: {
    bgImage: true,
    contentBlock: true
  }
};
